<template>
  <v-container>
    <v-card :class="{'elevation-2': $vuetify.breakpoint.smAndUp, 'elevation-0 rounded-0': $vuetify.breakpoint.xsOnly}">
      <v-form ref="form" lazy-validation
              :class="{'mb-8 py-10': $vuetify.breakpoint.smAndUp, 'mb-8 pt-10 pb-6': $vuetify.breakpoint.xsOnly}">
        <v-row justify="center">
          <v-col cols="11" class="pt-0">
            <Audience
              @audience="audienceHandler"
              @audiencePayload="audiencePayloadHandler"
              @audienceRule="audienceRuleHandler"
              @audiencePayloadRule="audiencePayloadRuleHandler"
              @audienceLoading="audienceLoadingHandler"
            />

            <h2 :class="{'mb-6 mt-10': $vuetify.breakpoint.mdAndUp, 'mb-6': $vuetify.breakpoint.smAndDown}"
                :style="{'font-size': $vuetify.breakpoint.smAndDown ? '20px' : '24px'}">Approver</h2>
            <v-row class="pa-0 ma-0">
              <v-col class="pa-0 ma-0" lg="6" md="6" sm="12">
                <v-select
                  color="#041E42"
                  v-model="approver"
                  label="Approver"
                  placeholder="Please select one..."
                  outlined
                  :rules="approverRule"
                  :items="approverOptions.map(e => e.name)"
                ></v-select>
              </v-col>
            </v-row>

            <h2 :class="{'mt-10': $vuetify.breakpoint.mdAndUp}"
                :style="{'font-size': $vuetify.breakpoint.smAndDown ? '20px' : '24px'}">Scheduling</h2>
            <v-radio-group class="mt-0 pb-3" v-model="scheduling" row>
              <v-radio v-for="option in scheduleOptions"
                       :key="option.code"
                       :label="option.label"
                       :value="option.code"
                       :class="'radioButton radioButtonSchedule radio' + option.code"
                       color="primary">
                <template v-slot:label>
                  <span class="d-flex align-center">
                    <v-icon
                      large
                      class="pl-1 pr-1"
                      color="primary"
                    >
                      {{ option.icon }}
                    </v-icon>
                     <span class="mb-0 ml-2">{{ option.label }}</span>
                  </span>
                </template>
              </v-radio>
            </v-radio-group>
            <v-row>
              <v-spacer/>
              <v-col cols="12" sm="6" lg="6" md="6" class="px-3 pt-0 d-flex flex-row"
                     v-if="this.scheduling === 'Later'">
                <v-icon class="mt-1" color="#041E42" style="height: fit-content;">mdi-alert-outline</v-icon>
                <p class="ml-3 mb-0 d-flex" style="font-size: 14px; vertical-align: middle;">If the notification's approval occurs after the
                  scheduled date/time, the
                  notification is
                  going to be sent immediately after being approved.</p>
              </v-col>
            </v-row>

            <template>
              <v-row justify="space-between" :class="$vuetify.breakpoint.smAndUp ? 'pr-3' : ''">
                <v-col cols="12" sm="4" md="4" lg="4" v-if="this.scheduling === 'Later'"
                       :class="{'pr-0': $vuetify.breakpoint.smAndUp}">
                  <v-text-field
                    @keydown.enter.prevent
                    v-model="scheduledDate"
                    v-if="scheduling === 'Later'"
                    label="Date"
                    type="date"
                    placeholder="DD/MM/YYYY"
                    :rules="dateRule"
                    @focus="setDateTimeDisplay('date')"
                    @blur="dateOnBlur"
                    class="mb-6"
                    outlined
                    required
                    :error="dateRule[0] !== true && scheduledDate !== '' "
                  />

                  <v-text-field
                    @keydown.enter.prevent
                    v-model="scheduledTime"
                    v-if="scheduling === 'Later'"
                    label="Time"
                    type="time"
                    step="300"
                    placeholder="--:--"
                    :rules="timeRule"
                    @focus="setDateTimeDisplay('time')"
                    @blur="timeOnBlur"
                    outlined
                    required
                    :error="timeRule[0] !== true && scheduledTime !== ''"
                  />
                  <div class="d-flex flex-row align-content-start">
                    <v-icon color="#041E42" style="height: fit-content;" class="mt-1">mdi-alert-outline</v-icon>
                    <p class="ml-3 mb-0 d-flex" style="font-size: 14px;">
                      Consider a variance of at most ± 20 minutes around the chosen time.
                    </p>
                  </div>
                </v-col>
                <v-col cols="12" sm="7" md="7" lg="7" :class="$vuetify.breakpoint.smAndUp ? 'pa-0 mt-3' : ''"
                       v-if="this.scheduling === 'Later'">
                  <v-date-picker
                    v-model="scheduledDate"
                    v-if="scheduling === 'Later' && dateOrTime === 'date'"
                    full-width
                    :landscape="$vuetify.breakpoint.mdAndUp"
                    :show-current="false"
                    :min="currentDate"
                    color="primary"
                    class="elevation-2 rounded"
                  >
                  </v-date-picker>

                  <v-time-picker
                    v-model="scheduledTime"
                    :allowed-minutes="m => !(m % 5)"
                    v-if="scheduling === 'Later' && dateOrTime === 'time'"
                    :full-width=true
                    :landscape="$vuetify.breakpoint.mdAndUp"
                    format="ampm"
                    :min="minimumTime"
                    class="elevation-2 rounded"
                    color="primary"/>
                </v-col>
              </v-row>
            </template>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <v-row :class="{'px-3': $vuetify.breakpoint.xsOnly}">
      <v-col lg="12"
             :class="{'pt-0 d-flex justify-space-between': $vuetify.breakpoint.smAndUp, 'pt-0 d-flex flex-column-reverse': $vuetify.breakpoint.xsOnly}">
        <AdsButton
          icon="delete"
          button-text="Discard"
          :id="$vuetify.breakpoint.xs ? 'discardButton' : null"
          secondary
          :class="{'mt-3': $vuetify.breakpoint.xsOnly}"
          @click="showDeleteDialog"
        />
        <div
          :class="{'pt-0 d-flex justify-end': $vuetify.breakpoint.smAndUp, 'pt-0 d-flex flex-column-reverse': $vuetify.breakpoint.xsOnly}">
          <AdsButton
            :loading="loadingSaveAndClose"
            button-text="Save & Close"
            tertiary
            @click="setupSubmit('close')"
            :disabled="!isValid || fieldOnFocus"
            :class="{'mr-3': $vuetify.breakpoint.smAndUp, 'mt-3': $vuetify.breakpoint.xsOnly}"
            style="height: 52px;"
          />
          <AdsButton
            :loading="loadingSaveAndContinue"
            button-text="Save & Continue"
            @click="setupSubmit('continue')"
            :disabled="!isValid || fieldOnFocus"
          />
        </div>
      </v-col>
    </v-row>
    <DiscardDialog
      v-model="deleteDialog"
      :delete-item="deleteItem"
      :show-delete-dialog="showDeleteDialog"/>
  </v-container>
</template>

<script>
import moment from 'moment';
import {SCHEDULE} from "@/static/data";
import {AdsButton} from '@nswdoe/doe-ui-core';
import DiscardDialog from "@/components/DiscardDialog";
import Audience from "@/components/qPlus/Audience";
import {getEmailDomain} from "@/utils/config";

export default {
  name: 'notificationStepThree',
  components: {
    AdsButton,
    DiscardDialog,
    Audience
  },
  data() {
    return {
      deleteDialog: false,
      loadingSaveAndClose: false,
      loadingSaveAndContinue: false,
      //Audience
      audience: "Individuals",
      audiencePayload: [],
      audienceRule: [],
      audiencePayloadRule: [],
      audienceLoading: false,

      //Approver
      approverOptions: [],
      approver: null,

      //Scheduling
      scheduleOptions: SCHEDULE,
      scheduling: 'Immediately',
      scheduledDate: "",
      currentDate: moment(Date.now()).format('YYYY-MM-DD'),
      scheduledTime: "",
      dateOrTime: 'date',
      timeRule: [],
      dateRule: [],
      fieldOnFocus: false
    }
  },
  computed: {
    emailDomain() {
      return getEmailDomain();
    },
    approverRule() {
      return [this.approver !== null || 'Please, select an approver option'];
    },
    minimumTime() {
      let min = "00:00";
      let today = new Date().toDateString();
      let currentDate = new Date(moment(this.scheduledDate).format()).toDateString();

      if (today === currentDate) {
        min = new Date().toTimeString().substring(0, 5);
      }
      return min;
    },
    isValid() {
      const rules = [this.audienceRule[0], this.approverRule[0], !this.audienceLoading];
      if (this.audience !== "Everyone") {
        rules.push(this.audiencePayloadRule[0]);
      }
      if (this.scheduling === 'Later') {
        rules.push(this.dateRule[0]);
        rules.push(this.timeRule[0]);
      }
      return rules.every(rule => rule === true);
    }
  },
  watch: {
    scheduledDate() {
      if (this.scheduledTime) {
        if (moment(this.scheduledDate + " " + this.scheduledTime).valueOf() < Date.now()) {
          this.dateRule = ['Your scheduled date/time needs to be a future date'];
        } else {
          this.dateRule = [true];
          this.timeRule = [true];
        }
      } else {
        this.dateRule = [true];
      }
    },
    scheduledTime() {
      if (this.scheduledDate) {
        if (moment(this.scheduledDate + " " + this.scheduledTime).valueOf() < Date.now()) {
          this.timeRule = ['Your scheduled date/time needs to be a future date'];
        } else {
          this.timeRule = [true];
          this.dateRule = [true];
        }
      } else {
        this.timeRule = [true];
      }
    }
  },
  methods: {
    audienceHandler(audience) {
      this.audience = audience;
    },
    audiencePayloadHandler(audiencePayload) {
      this.audiencePayload = audiencePayload;
    },
    audienceRuleHandler(rule) {
      this.audienceRule = rule;
    },
    audiencePayloadRuleHandler(rule) {
      this.audiencePayloadRule = rule;
    },
    audienceLoadingHandler(isLoading) {
      this.audienceLoading = isLoading;
    },
    setDateTimeDisplay(val) {
      this.dateOrTime = val;
      this.fieldOnFocus = true;
    },
    parseTime(str) {
      // first two digits
      let hours = Number(str.substr(0, 2));
      // last two digits
      let minutes = Number(str.substr(3, 2));
      if (minutes % 5 !== 0) {
        minutes = (minutes + 5) - ((minutes + 5) % 5);
        if (minutes % 60 === 0) {
          hours += 1;
        }
        minutes = String(minutes % 60);
      }
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    },
    timeOnBlur() {
      if (!this.scheduledTime) {
        this.timeRule = ['Please, insert a valid time'];
      } else {
        this.scheduledTime = this.parseTime(this.scheduledTime);
        if (this.scheduledDate) {
          if (moment(this.scheduledDate + " " + this.scheduledTime).valueOf() < Date.now()) {
            this.timeRule = ['Your scheduled date/time needs to be a future date'];
          } else {
            this.timeRule = [true];
            this.dateRule = [true];
          }
        } else {
          this.timeRule = [true];
        }
      }
      this.fieldOnFocus = false;
    },
    dateOnBlur() {
      if (!this.scheduledDate) {
        this.dateRule = ['Please, insert a valid date'];
      } else if (this.scheduledTime) {
        if (moment(this.scheduledDate + " " + this.scheduledTime).valueOf() < Date.now()) {
          this.dateRule = ['Your scheduled date/time needs to be a future date'];
        } else {
          this.dateRule = [true];
          this.timeRule = [true];
        }
      } else {
        this.dateRule = [true];
      }
      this.fieldOnFocus = false;
    },
    parseDateAndTime(date, time) {
      return moment(date + " " + time).utc().format();
    },
    formatDateAndTime(date) {
      date = moment(new Date(date)).format("YYYY-MM-DD hh:mm a").split(" ");
      const scheduledDate = date[0];
      let scheduledTime = date[1];
      if (date[2] === 'pm') {
        let scheduledTimeArray = scheduledTime.split(":");
        scheduledTimeArray[0] = String(Number(scheduledTimeArray[0]) + 12);
        scheduledTime = scheduledTimeArray.join(":");
      }
      return [scheduledDate, scheduledTime];
    },
    setupSubmit(next) {
      if (next === 'close') {
        this.loadingSaveAndClose = true;
      }
      if (next === 'continue') {
        this.loadingSaveAndContinue = true;
      }
      const approverEmail = this.approverOptions.find(a => a.name === this.approver).emailAddress || null;
      const isScheduled = this.scheduling === 'Later';
      let scheduledDateTime = this.parseDateAndTime(this.scheduledDate, this.scheduledTime);
      if (scheduledDateTime === 'Invalid date') scheduledDateTime = null;

      if (this.isValid) {
        const formData = {
          audience: {
            type: this.audience,
            roles: [],
            emails: this.audience === 'Individuals' ? this.audiencePayload.map(userid => userid + this.emailDomain) : [],
          },
          approverEmail: approverEmail,
          scheduling: {
            isScheduled: isScheduled,
            payload: scheduledDateTime
          }
        }
        this.$store.commit('setNotificationAudienceAndScheduling', formData);
        this.$store.commit('setNotificationInfo', {status: 'Draft'});
        let draftPage = 3;
        if (this.$store.getters.currentNotification.draftPage > 3) {
          draftPage = this.$store.getters.currentNotification.draftPage;
        }
        this.$store.dispatch('updateNotification', draftPage)
          .then(() => {
            if (next === 'close') {
              this.$store.commit('setAlert', 'draft');
              this.$emit('close');
            } else {
              this.$emit('progress');
            }
          })
          .catch(err => {
            if (next === 'close') {
              this.$store.commit('setAlert', 'draftError');
              this.$router.push({name: 'qPlusNotifications'});
              setTimeout(() => {
                this.$store.commit('setShowAlert', false);
                this.$store.commit('setAlert', '');
              }, 2000);
            } else {
              if (err.response && err.response.data.errMsg) {
                err = `<p>${err}</p>
                   <p>Description: ${err.response.data.errMsg}</p>`
              } else {
                err = `<p>${err}.</p>`
              }
              this.$store.commit('setErrorMessage', err);
              this.$router.push({name: 'error'});
            }
          })
          .finally(() => {
            if (next === 'close') {
              this.loadingSaveAndClose = false;
            }
            if (next === 'continue') {
              this.loadingSaveAndContinue = false;
            }
          });
      }
    },
    showDeleteDialog() {
      this.deleteDialog = !this.deleteDialog;
    },
    deleteItem() {
      this.$store.dispatch("deleteNotification", this.$store.getters.currentNotification.draftId)
        .finally(() => {
          this.deleteDialog = false;
          this.$store.commit('setCreateMode', false);
          this.$router.push({name: "notifications"});
        });
    },
  },
  created() {
    this.$store.dispatch('fetchQplusApprovers')
      .then(() => {
        this.approverOptions = this.$store.getters.approvers;
        if (this.$store.getters.currentNotification) {
          const approverEmail = this.$store.getters.notificationAudienceAndScheduling.approverEmail;
          const approver = this.approverOptions.find(a => a.emailAddress === approverEmail);
          this.approver = approver ? approver.name : null;
        }
      });
    if (this.$store.getters.currentNotification) {
      this.scheduling = this.$store.getters.notificationAudienceAndScheduling.scheduling.isScheduled ?
        'Later' : 'Immediately';
      let scheduledDateAndTime = this.$store.getters.notificationAudienceAndScheduling.scheduling.payload;
      if (scheduledDateAndTime) {
        let [scheduledDate, scheduledTime] = this.formatDateAndTime(scheduledDateAndTime);
        this.scheduledDate = scheduledDate;
        this.scheduledTime = scheduledTime;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-input--radio-group--row .v-input--radio-group__input {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.radioButton {
  border: 1px solid #6D7079;
  border-radius: 4px;
  padding: 20px;
  height: 100px;
  margin-top: 24px;
  margin-right: 0 !important;
}

.radioButtonAudience {
  width: calc(100% / 3 - 12px);
}

@media only screen and (max-width: 960px) {
  .radioButtonAudience {
    width: calc(100% / 2 - 12px);
  }
}

@media only screen and (max-width: 600px) {
  .radioButtonAudience {
    width: 100%;
  }
}

.radioEveryone {
  margin-right: 0 !important;
}

.radioButtonSchedule {
  min-width: calc(100% / 2 - 12px);
}


@media only screen and (max-width: 600px) {
  .radioButtonSchedule {
    min-width: 100%;
  }
}

.v-item--active {
  border: 2px solid #041E42;
  background-color: #DADADA;
}

.v-chip {
  background-color: #C8DCF0 !important;
  border: 1px solid #041E42;
}

.v-chip.loading {
  opacity: 0.5;
}

.v-chip.invalid {
  background-color: #B91237 !important;
  border: none;
  color: #FFFFFF;

  ::v-deep .v-chip__content button.v-icon {
    color: #FFFFFF;
  }
}
</style>
